// extracted by mini-css-extract-plugin
export default {"header":"header_header__PXGD2","imgBg":"header_imgBg__S-hKC","headerContent":"header_headerContent__vH1cO","imgLogo":"header_imgLogo__-ckLO","bg":"header_bg__7b3Qv"};